import React from 'react';

import { flagStyles } from '../settings';

const SvgJO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2664px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgJO;
